import React, {useState, useEffect } from 'react'
import { useParams } from 'react-router-dom';
import { styled } from "@mui/material/styles";
import { Typography, Button, Container, Paper, TextField, IconButton, Stack } from '@mui/material';
import { Image } from 'mui-image'
import EditNoteIcon from '@mui/icons-material/EditNote';
import InsertEmoticonIcon from '@mui/icons-material/InsertEmoticon';
import Comment from '../components/Comments'
import { Helmet } from "react-helmet-async";

const StyledContainer = styled(Container)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'space-around'  
}));

const Article = () => {
  let params = useParams()
  let articleId = params.articleId

  let [ article, setArticle ] = useState({})
  const backend = 'https://oureclecticsociety.org/core'

  useEffect(() => {
    getArticle()
  },[])

  let getArticle = async () => {
    let response = await fetch(`${backend}/articles/${articleId}`)
    let data = await response.json()
    setArticle(data)
  }

  let [ likes, setLikes ] = useState({})

  let getLikes = async () => {
    let response = await fetch(`${backend}/likes/${articleId}`)
    let data = await response.json()
    setLikes(data)
  }

  useEffect(() => {
    getLikes()
  },[])

  const [input, setInput] = useState('')

  const handleSubmit = (e) => {
    e.preventDefault()

    if(input){

      fetch(`${backend}/comment-create/`, {
        method : 'POST',
        headers : {"Content-type": "application/json"},
        body: JSON.stringify({"comment": input, "article": articleId })
      })

    }
    else{
      setInput('')
    }

    window.location.reload()
     
  }

  const formatBodyContent = (body) => {
      if (body !== undefined) {
        const groupedRecords = []
        let blogItems = body.split('.')

        for(let index= 0; index < blogItems.length; index += 5) {
          groupedRecords.push(blogItems.slice(index, index + 5).join("."))
        }

        const blogData = groupedRecords.map(sentence => `<p>${sentence.trim().concat(".")}</p><br><br>`)
        const item = blogData.join("")

        return <div dangerouslySetInnerHTML={{__html: item }} />
      } else {
        return "";
      }
  }

  const handleLike = (likes) => {

    const newLikes = likes.like + 1
    
    fetch(`${backend}/likes-update/${articleId}/`, {
        method : 'PUT',
        headers : {"Content-type": "application/json"},
        body: JSON.stringify({"id": articleId, "like": newLikes, "article": articleId })
      })
    
  }
  
  return (
    <Container sx={{ mb: 5 }} >

      <Helmet>
        <title>OES | Article</title>
        <meta name="description"
          content="Share in our thoughts on African politics, culture, economy and growth through this article's discussion"
        />
        <meta
          name="keywords"
          content="African, Nairobi, Growth, Economy, Culture, History, Politics, Society, Eclectic"
        />
        <meta property="og:title" content="Our Eclectic Society" />
        <meta property="og:description" content="Mindful thoughts and discussions about our continent" />
        {/* <meta property="og:image" content={img1} />
        <meta property="og:image:width" content="600" />
        <meta property="og:image:height" content="400" /> */}
        <link rel="canonical" href="/article/:articleId" />
      </Helmet>
      
      <StyledContainer>
        <Typography className='article' variant='h3' color="text.primary" sx={{ my: 5, fontWeight: 'bold'}} >{article.title}</Typography>
      </StyledContainer>
      <Paper sx={{ p: 3 }}>
        <StyledContainer>
          {/* <Image src={`http://localhost:8000${article.image}`} width= "100%" height={500} sx={{ mb: 3 }}/> */}
          <Image src={`${article.image}`} width= "100%" height={500} sx={{ mb: 3 }}/>
        </StyledContainer>
          { formatBodyContent(article.body) }
      </Paper>
      <Stack direction="row" spacing={3}>
        <Typography sx={{ mt: 1 }}>Likes : {likes.like} </Typography>
        <IconButton sx={{color:'orange'}} onClick={ () => { handleLike(likes); window.location.reload() } }>
          <InsertEmoticonIcon />
          <Typography>Like</Typography>
        </IconButton>
      </Stack>
      <Typography variant='h5' color="text.primary" marginTop= "20px" marginBottom= "20px"> Comments</Typography>
      <form noValidate onSubmit={ handleSubmit }>
        <TextField onChange={(e) => setInput(e.target.value) } label="Anything to say...?" variant="outlined" multiline rows={2} fullWidth/>
        <Button sx={{ mt: 3 }} type="submit" variant="contained" endIcon={<EditNoteIcon />}>Submit</Button>
      </form>
      <Comment articleId={articleId}/>
    </Container>
    
  )
}

export default Article
